module.exports = __webpack_public_path__ + "zmenseni-prsou_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zmenseni-prsou_1_before_tn.jpg
// module id = 1746
// module chunks = 0